
import React, { useEffect, useRef, useState } from "react";
const TermsConditions = ({ onAccept, onClose }) => {
    const appName = process.env.REACT_APP_NAME || "Your Platform";
  const [canAccept, setCanAccept] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    if (el.scrollHeight <= el.clientHeight) {
      setCanAccept(true);
    }
  }, []);

  const handleScroll = () => {
    const el = contentRef.current;
    if (!el) return;

    const scrollPosition = el.scrollTop + el.clientHeight;
    const scrollHeight = el.scrollHeight;

    if (scrollPosition >= scrollHeight - 2) {
      setCanAccept(true);
    }
  };

  return (
    
    <div className="terms-content">

      {/* ✅ Close Button Yaha Add Karo */}
      <button className="close-btn" onClick={onClose}>
        ✕
      </button>
       <div
        className="terms-scroll-content"
        ref={contentRef}
        onScroll={handleScroll}
      >
      <h3>TERMS AND CONDITIONS</h3>



      <h4>1. Crypto Exchange, Trading & Investment Disclaimer General Disclaimer
</h4>
      <p>
        {appName} Company provides a platform for cryptocurrency exchange, trading, and digital asset investment services. 
        By accessing or using this platform, users acknowledge and agree that cryptocurrency trading and investments involve substantial risk.
      </p>
      <p>The services provided by the platform are intended solely for informational and transactional purposes. The company does not guarantee the accuracy, 
        completeness, or reliability of any information provided on the platform.</p>
      <p>All users are responsible for conducting their own research and making independent investment decisions.</p>

      <h4>2. No Financial or Investment Advice</h4>
      <p>
       The information available on this platform, including but not limited to market data, trading signals, price charts, educational articles, 
       and analytics, is provided for informational and educational purposes only.      </p>

      <h4>3. Nothing on this platform should be considered as:</h4>
       <ul>
        <li>Financial advice</li>
        <li>Investment advice </li>
        <li>Trading advice</li>
        <li>Legal or tax advice</li>
      </ul>
      <p>
        Users should consult qualified financial advisors or professionals before making any investment decisions.

      </p>
     

      <h4>4. Cryptocurrency Risk Warning</h4>
      <p>Cryptocurrencies and digital assets are highly volatile and speculative investments. Prices can fluctuate rapidly due to market demand, regulatory changes, 
        technological developments, or other external factors.</p>
        <p>Users acknowledge and accept the following risks:</p>
      <ul>
        <li>High market volatility</li>
        <li>Liquidity risks</li>
        <li>Regulatory and legal uncertainty</li>
        <li>Cybersecurity risks and hacking incidents</li>
        <li>Technology risks including blockchain failures</li>
        <li>Potential total loss of invested capital</li>
        <li>You should only invest funds that you can afford to lose.</li>
        <li>Trading Risk Disclosure</li>
        <li>Trading cryptocurrencies involves significant risk and may not be suitable for all investors.</li>
        <li>Key trading risks include:</li>
        <li>Rapid price fluctuations</li>
        <li>Slippage during market volatility</li>
        <li>Liquidation risks in leveraged trading</li>
        <li>System or network outages</li>
        <li>Market manipulation or abnormal market conditions</li>
        <li>Past performance of any cryptocurrency, trading strategy, or investment product does not guarantee future results.</li>
        <li>Platform Availability</li>
        <li>While {appName} Company strives to provide uninterrupted services, the platform does not guarantee that services will always be available without interruption.</li>
        <li>The platform may experience downtime due to:</li>
        <li>System maintenance</li>
        <li>Network failures</li>
        <li>Blockchain congestion</li>
        <li>Security incidents</li>
        <li>Technical issues</li>
        <li>{appName} Company shall not be held liable for losses resulting from service interruptions.</li>
      </ul>

      <h4>5. Limitation of Liability</h4>
      <p>
        To the fullest extent permitted by law, we shall not be liable for:
      </p>
      <ul>
        <li>Loss of funds due to user negligence</li>
        <li>Blockchain network congestion</li>
        <li>Gas fee fluctuations</li>
        <li>Third-party wallet malfunctions</li>
        <li>Force majeure events</li>
      </ul>

      <h4>6. Third-Party Services</h4>
      <p>
        The platform may include links or integrations with third-party services, wallets, payment gateways, or blockchain networks.
      </p>
      <p>{appName} Company does not control and is not responsible for the performance, security, or reliability of third-party services.</p>
      <p>Users interact with third-party services at their own risk.</p>

      <h4>7. Regulatory Compliance</h4>
      <p>
      Cryptocurrency regulations vary by jurisdiction. It is the user's responsibility to ensure compliance with the laws and regulations 
      applicable in their country or region before using the platform.
      </p>
      <p>Certain services may not be available in restricted jurisdictions.</p>
      <p>Security Responsibility</p>
      <p>Users are responsible for maintaining the security of their accounts, including:</p>
      <p>Safeguarding passwords</p>
      <p>Enabling two-factor authentication (2FA)</p>
      <p>Protecting private keys or wallet credentials</p>
      <p>{appName} Company will never request your password or private keys.</p>
      <p>Losses caused by compromised accounts due to user negligence may not be recoverable. </p>
      <h4>8. Limitation of Liability</h4>
      <p>
       {appName} Company shall not be liable for any direct, indirect, incidental, consequential, or special damages arising from:
      </p>
      <p>Cryptocurrency trading losses</p>
      <p>Market volatility</p>
      <p>Platform usage</p>
      <p>Third-party service failures</p>
      <p>Unauthorized account access</p>
      <p>Users acknowledge that all trading and investment activities are undertaken at their own risk.</p>
      <h4>9. Acceptance of Terms</h4>
      <p>
      By using this platform, users confirm that they have read, understood, and agreed to this disclaimer and risk disclosure.
      </p>
   </div>
      <button
        className="button-animation mt-3"
        disabled={!canAccept}
        style={{
          opacity: canAccept ? 1 : 0.5,
          cursor: canAccept ? "pointer" : "not-allowed"
        }}
        onClick={onAccept}
      >
        Accept
      </button>
    </div>
   
  );
};

export default TermsConditions;